import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_EMAIL = createActionTypes('FETCH_EMAIL');
export const GET_EMAIL = createActionTypes('GET_EMAIL');
export const CREATE_EMAIL = createActionTypes('CREATE_EMAIL');
export const UPDATE_EMAIL = createActionTypes('UPDATE_EMAIL');
export const DELETE_EMAIL = createActionTypes('DELETE_EMAIL');
